// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__XbwvU","iconButton":"IconButton_icon-button__XbwvU","image":"IconButton_image__IV9lv"};